const Ldjson = ({ props, summary = '', url, related_image_url = '', authors, sections, sectionUrl, isLiveBlogs = false }) => {

    
    let customBreadcrum;

    if (sections && sections.length > 0) {
        customBreadcrum = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": []
        }

        const breadList = sections.map((section, index) => {
            return {
                "@type": "ListItem",
                "position": index + 1,
                "name": section.name?.toUpperCase(),
                "item": `${process.env.NEXT_PUBLIC_DOMAIN_URL}${sectionUrl}`
            }

        })

        customBreadcrum.itemListElement = breadList;
    }

    let data = [];

    let publishedDateFormatZ;
    let modificatedAtFormatZ;
    
    try {
      publishedDateFormatZ = new Date(props.publishedDate).toISOString();
      modificatedAtFormatZ = new Date(props.modificatedAt).toISOString();
    } catch (e) {
      publishedDateFormatZ = new Date().toISOString();
      modificatedAtFormatZ = new Date().toISOString();
    }

    const LdArticle = {
        "@context": "http://schema.org",
        "@type": "NewsArticle",
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": url
        },
        "headline": props.title,
        "alternativeHeadline": props.subtitle,
        "url": url,
        "image": [{
            "@context": "http://schema.org",
            "@type": "ImageObject",
            "url": related_image_url,
            "height": 1500,
            "width": 2000
        }],
        "dateCreated": publishedDateFormatZ,
        "datePublished": publishedDateFormatZ,
        "dateModified": modificatedAtFormatZ,
        "description": summary,
        "articleSection": props.sections.map((e) => e.name),
        "author": (authors && authors.length > 0) ? authors.map((author) => ({ type: "Person", name: author.name, url: 'https://www.ellitoral.com/autor/' + author.slug })) : [{
            type: "Organization",
            name: "Redacción El Litoral",
            url: "https://www.ellitoral.com",
        }],
        "keywords": props.tags.map((e) => e.name),
        "publisher": {
            "@type": "Organization",
            "name": "Diario El Litoral",
            "url": "https://www.ellitoral.com",
            "logo": {
                "@type": "ImageObject",
                "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
                "width": 439,
                "height": 60
            },
            "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://www.youtube.com/c/EllitoralArgentina"]
        },
    };

    data.push(LdArticle);

    if (customBreadcrum) {
        data.push(customBreadcrum);
    }

    return (
        <>
            {
                !isLiveBlogs && (
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: JSON.stringify(data)
                        }}
                    />
                )
            }
        </>
    );
}

export default Ldjson;